import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import styles from './Start.module.scss';
import classNames from 'classnames';
import { OPERATOR, DRIVER, LAB, FILLER, stories } from '@/src/constants';
import { createText } from '@/src/utils/createText';
import { Footer } from '@/src/components/Footer';
import { CSSTransition } from 'react-transition-group';
import sendEventToCounters from '@/src/counterEvents';

type TProps = {
  changePage: (pageName: string) => void;
  setActiveStory: Dispatch<SetStateAction<string>>;
};

export const Start = ({ changePage, setActiveStory }: TProps) => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  const [isAnimated, setIsAnimated] = useState(false);
  const [isAnimatedContent, setIsAnimatedContent] = useState(false);

  let timerId: ReturnType<typeof setTimeout>;

  useEffect(() => {
    timerId = setTimeout(() => {
      setIsAnimated(true);
      setIsAnimatedContent(true);
    }, 1);

    return () => clearTimeout(timerId);
  }, []);

  const [activeHero, setActiveHero] = useState(OPERATOR);
  const [animationHero, setAnimationHero] = useState(OPERATOR);

  const handleChooseHero = (hero: string) => {
    setIsAnimated(false);
    setIsAnimatedContent(false);
    setAnimationHero(hero);
    setTimeout(() => {
      setActiveHero(hero);
      setIsAnimated(true);
      setIsAnimatedContent(true);
      window.scrollTo(0, 0);
    }, 300);
  };

  const handleGoGame = () => {
    setActiveStory(activeHero);
    changePage('game');
    switch (activeHero) {
      case OPERATOR:
        sendAnalytics('kassir_azs');
        break;
      case DRIVER:
        sendAnalytics('voditel');
        break;
      case LAB:
        sendAnalytics('laborant');
        break;
      case FILLER:
        sendAnalytics('napolnitel');
        break;
      default:
        break;
    }
  };

  const sendAnalytics = (action: string) => {
    sendEventToCounters({ action, label: 'my_history' });
  };

  return (
    <div className={classNames(styles.start, 'start')}>
      <div className={styles.top}>
        <div className={classNames('container', styles.container)}>
          <div className={classNames(styles.topWrapper, styles[activeHero])}>
            <CSSTransition
              in={isAnimated}
              timeout={200}
              classNames={
                animationHero === LAB ? 'fadeStartLeft' : 'fadeStartRight'
              }
            >
              <div
                className={classNames(
                  styles.image,
                  animationHero === LAB ? 'fadeStartLeft' : 'fadeStartRight',
                  'fadeImage',
                )}
              >
                <img src={stories[activeHero].image} alt="" />
              </div>
            </CSSTransition>
            <CSSTransition
              in={isAnimated}
              timeout={200}
              classNames="fadeStartRight"
            >
              <div
                className={classNames(
                  styles.imageBg,
                  'fadeStartRight',
                  'fadeImage',
                )}
              ></div>
            </CSSTransition>
            <div className={styles.wrap}>
              <CSSTransition
                in={isAnimated}
                timeout={200}
                classNames="fadeStartLeft"
              >
                <div
                  className={classNames(
                    styles.wrapTop,
                    'fadeStartLeft',
                    'fadeTitle',
                  )}
                >
                  <div
                    className={styles.title}
                    dangerouslySetInnerHTML={createText(
                      stories[activeHero].title,
                    )}
                  ></div>
                </div>
              </CSSTransition>
              <CSSTransition
                in={isAnimatedContent}
                timeout={200}
                classNames={
                  animationHero === LAB ? 'fadeStartRight' : 'fadeStartLeft'
                }
              >
                <div
                  className={classNames(
                    styles.contentWrap,
                    animationHero === LAB ? 'fadeStartRight' : 'fadeStartLeft',
                    'fadeContent',
                  )}
                >
                  <div className={styles.content}>
                    <div
                      className={styles.contentTitle}
                      dangerouslySetInnerHTML={createText(
                        stories[activeHero].startText.title,
                      )}
                    ></div>
                    {stories[activeHero].startText.text && (
                      <p
                        dangerouslySetInnerHTML={createText(
                          stories[activeHero].startText.text,
                        )}
                      ></p>
                    )}
                    <button
                      className={classNames('button', styles.startButton)}
                      onClick={handleGoGame}
                    >
                      Моя история
                    </button>
                  </div>
                  <div className={styles.list}>
                    <div
                      className={classNames(styles.item, styles['operator'], {
                        [styles.active]: activeHero === OPERATOR,
                      })}
                      onClick={() => handleChooseHero(OPERATOR)}
                    ></div>
                    <div
                      className={classNames(styles.item, styles['driver'], {
                        [styles.active]: activeHero === DRIVER,
                      })}
                      onClick={() => handleChooseHero(DRIVER)}
                    ></div>
                    <div
                      className={classNames(styles.item, styles['lab'], {
                        [styles.active]: activeHero === LAB,
                      })}
                      onClick={() => handleChooseHero(LAB)}
                    ></div>
                    <div
                      className={classNames(styles.item, styles['filler'], {
                        [styles.active]: activeHero === FILLER,
                      })}
                      onClick={() => handleChooseHero(FILLER)}
                    ></div>
                  </div>
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <Footer />
      </div>
    </div>
  );
};
